import type { CollectionChain } from 'lodash';

import { HabitatListItem } from '@/queries/habitats/types';

type HabitatsChain<T extends HabitatListItem = HabitatListItem> = CollectionChain<T>;

// eslint-disable-next-line import/prefer-default-export
export const searchHabitats = <T extends HabitatListItem = HabitatListItem>(habitats: HabitatsChain<T>, query: string) =>
  habitats
    .map((habitat) => {
      const { title, animal, hidden, zoo, keywords, isStreamOn, animals } = habitat;
      if (hidden || (!query && !isStreamOn)) {
        return null;
      }
      if (!query) {
        return [habitat, 0];
      }
      if (title?.toLowerCase().includes(query)) {
        return [habitat, 1];
      }
      if (animal?.toLowerCase().includes(query)) {
        return [habitat, 2];
      }
      if (animals?.some((animal) => animal.name.toLowerCase().includes(query))) {
        return [habitat, 2];
      }
      if (zoo.name.toLowerCase().includes(query)) {
        return [habitat, 3];
      }
      // we converted the keywords to lower case when we saved them in the DB
      if (keywords?.some((keyword) => keyword.includes(query))) {
        return [habitat, 4];
      }
      return null;
    })
    .filter((data): data is [T, number] => data != null)
    .sortBy(([, score]) => score);
